export const SUBCONTRACTOR_RA_BILL_LABEL = "Subcontractor RA Bill";
export const LABOUR_CHARGES_LABEL = "Labour Charges";

export function timelineBillLineLabel(phaseTitle: string, kind: "subcontractor" | "labour"): string {
  const title = phaseTitle.trim();
  const suffix = kind === "labour" ? LABOUR_CHARGES_LABEL : SUBCONTRACTOR_RA_BILL_LABEL;
  return title ? `${title} — ${suffix}` : suffix;
}

/** Reference / milestone block for timeline-based invoices. */
export function timelineReferenceTitles(phaseTitles: string[]): string {
  return [...new Set(phaseTitles.map((t) => t.trim()).filter(Boolean))].join(", ");
}
